/* eslint-disable no-param-reassign */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const name = "holidays";

// holiday dates stored as "yyyy-MM-dd" strings
type HolidaysState = {
  dates: DateString[];
};

const initialState: HolidaysState = {
  dates: [],
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    setAll: (state, action: PayloadAction<DateString[]>) => {
      state.dates = action.payload;
    },
  },
});

export const { actions } = slice;

export default {
  [name]: slice.reducer,
};
